var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileCover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 123,
    viewBox: "0 0 306 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_828_2000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 306,
    height: 123,
    rx: 10,
    fill: "#E1EBF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7501 84.6011C30.7501 99.7889 18.438 112.101 3.25013 112.101C-11.9377 112.101 -24.2499 99.7889 -24.2499 84.6011C-24.2499 69.4132 -39.4378 21 -24.25 21C-9.06217 21 30.7501 69.4132 30.7501 84.6011Z",
    fill: "#97D8C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.242 100.293C346.242 132.602 303.809 202.793 271.5 202.793C239.191 202.793 213 176.602 213 144.293C213 111.984 224.191 69.0036 256.5 69.0036C288.809 69.0036 346.242 67.9843 346.242 100.293Z",
    fill: "#24164c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: -11,
    r: 52,
    fill: "#F18902"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.5,
    cy: 29.5,
    r: 14.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 30.25C271.69 30.25 272.25 29.6904 272.25 29C272.25 28.3096 271.69 27.75 271 27.75C270.31 27.75 269.75 28.3096 269.75 29C269.75 29.6904 270.31 30.25 271 30.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 30.25C276.69 30.25 277.25 29.6904 277.25 29C277.25 28.3096 276.69 27.75 276 27.75C275.31 27.75 274.75 28.3096 274.75 29C274.75 29.6904 275.31 30.25 276 30.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 30.25C281.69 30.25 282.25 29.6904 282.25 29C282.25 28.3096 281.69 27.75 281 27.75C280.31 27.75 279.75 28.3096 279.75 29C279.75 29.6904 280.31 30.25 281 30.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_828_2000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 306,
    height: 123,
    rx: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCover);
export default __webpack_public_path__ + "static/media/ProfileCover.d147a3dc9c75658d3fcacb053a9873c4.svg";
export { ForwardRef as ReactComponent };